import React from "react";
import "./Modal.css";

const SubItemsModal = ({ item, onClose, onSubItemClick }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{item.title}</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <h3>العناوين الفرعية:</h3>
          <div className="subitems-list">
            {item.subItems?.map((subItem) => (
              <div
                key={subItem.id}
                className="subitem-card"
                onClick={() => onSubItemClick(subItem)}
              >
                <h4>{subItem.title}</h4>
                <span className="click-hint">انقر لعرض المقال</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubItemsModal;
